import { Navbar } from "@/components/Navbar";
import { WelcomeOverlay } from "@/components/WelcomeOverlay";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { WhyUs } from "@/components/WhyUs";
import { Portfolio } from "@/components/Portfolio";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";

export default function Home() {
  return (
    <div className="bg-[#1A1412] min-h-screen" data-testid="home-page">
      <div className="grain-overlay" />
      <WelcomeOverlay />
      <Navbar />
      <Hero />
      <Services />
      <Process />
      <WhyUs />
      <Portfolio />
      <Reviews />
      <Contact />
      <Footer />
      <FloatingButtons />
    </div>
  );
}
